import React from 'react';
import styled from 'styled-components';
import TransitionLink from 'gatsby-plugin-transition-link';

const Button = ({ children, to, gatsbyLink }) =>
  gatsbyLink ? (
    <ButtonLink to={to} exit={{ length: 0.5 }} entry={{ length: 0.5 }}>
      {children}
    </ButtonLink>
  ) : (
    <ButtonA href={to} target='_blank' rel='noreferrer'>
      {children}
    </ButtonA>
  );

const ButtonLink = styled(TransitionLink)`
  background-color: #b82c97;
  color: #ffffff;
  padding: 16px 24px;
  text-decoration: none;
  border-radius: 5px;
  font-weight: 500;
  margin-bottom: 1rem;
  display: inline-block;
  transition: background-color 0.2s;
  text-align: center;

  :hover,
  :focus {
    background-color: #9e2682;
    color: #ffffff;
  }
`;
const ButtonA = styled.a`
  background-color: #b82c97;
  color: #ffffff;
  padding: 12px 25px;
  text-decoration: none;
  border-radius: 5px;
  font-weight: 500;
  margin-bottom: 1rem;
  display: inline-block;
  transition: all 0.2s;
  @media (max-width: 900px) {
    text-align: center;
  }
  :hover,
  :focus {
    background-color: #9e2682;
    color: #ffffff;
    text-decoration: none;
  }
`;

export default Button;
